import axios from '../../../services/axios';

const CROPWISE_API_BASE_URL = import.meta.env.VITE_APP_CROPWISE_API_URL;

export const getFieldsByPropertyId = async (
  property_id: string,
  access_token: string,
  controller?: AbortController,
) => {
  try {
    const response: any = await axios.request({
      method: 'GET',
      url: `${CROPWISE_API_BASE_URL}/v2/properties/${property_id}/fields`,
      headers: { Authorization: `Bearer ${access_token}` },
      params: { attributes: 'geometry' },
      signal: controller?.signal,
    });
    return response.data.content;
  } catch (err: any) {
    console.error('getFieldsByPropertyId error:', err);
    return err;
  }
};
